import LoaderIcon from '@lt/components/icons-react/rebrand/Loader';
import React from 'react';
import styled from 'styled-components';
import {
  TEST_ID_FILTER_BUTTON_FETCHING,
  TEST_ID_FILTER_BUTTON_ITEMS,
} from './constants';

export interface FilterButtonProps {
  title: string;
  name: string;
  isFetching?: boolean;
  count: number;
  isSelected: boolean;
  onClick: ({
    name,
    isSelected,
  }: {
    name: string;
    isSelected: boolean;
  }) => void;
}

export const FilterButton = ({
  title,
  count,
  onClick,
  isFetching = false,
  name,
  isSelected,
}: FilterButtonProps) => {
  const handleClick = () => {
    // При нажатии отправляем измененное значение
    onClick({ name, isSelected: !isSelected });
  };
  return (
    <StyledFilterButton
      $isSelected={isSelected}
      $isFetching={isFetching}
      onClick={handleClick}
    >
      {isFetching && (
        <StyledLoaderIcon
          $isFetching={isFetching}
          data-testid={TEST_ID_FILTER_BUTTON_FETCHING}
        />
      )}
      <StyledContent data-testid={TEST_ID_FILTER_BUTTON_ITEMS}>
        <StyledTitle>{title}</StyledTitle>
        <StyledCount>{count}</StyledCount>
      </StyledContent>
    </StyledFilterButton>
  );
};

const StyledContent = styled.div`
  display: flex;
`;

const StyledTitle = styled.div`
  font-size: 14px;
`;

const StyledCount = styled.div`
  margin: auto 0 auto 4px;
`;

export const StyledFilterButton = styled.div<{
  $isSelected: boolean;
  $isFetching: boolean;
}>`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  width: fit-content;
  cursor: ${({ $isFetching }) => ($isFetching ? 'default' : 'pointer')};
  padding: 12px 16px;
  border-radius: var(--border-radius);
  background: ${({ $isSelected, $isFetching }) =>
    $isSelected || $isFetching ? 'var(--secondary)' : 'var(--white)'};
  position: relative;
  ${StyledContent} {
    visibility: ${({ $isFetching }) => ($isFetching ? 'hidden' : 'visible')};
  }
  ${StyledTitle} {
    color: ${({ $isSelected }) =>
      $isSelected ? 'var(--white)' : 'var(--black)'};
  }
  ${StyledCount} {
    opacity: 0.5;
    color: ${({ $isSelected }) =>
      $isSelected ? 'var(--white)' : 'var(--black)'};
  }
`;

const StyledLoaderIcon = styled(LoaderIcon)<{ $isFetching: boolean }>`
  animation: var(--loader-animation);
  height: 13px;
  path {
    fill: var(--white);
  }
`;
